"use strict";
(function(){
    var _events = new Object();
    var EventDispatcher = function(){
        this._dispatcher = document.createElement('div');
    };
    EventDispatcher.prototype = {
        
        
        
        hasEventListener:function(type){
            return _events.hasOwnProperty(type);
        },
        addEventListener:function(type, cb){
            _events[type] = cb;
            this._dispatcher.addEventListener(type, cb);
        },
        removeEventListener:function(type,cb){
            if(this.hasEventListener(type) && _events[type] === cb){
                delete _events[type];
                this._dispatcher.removeEventListener(type, cb);
            } else {
                console.log('trying to remove an event that was not adde');
            }
        },
        dispatchEvent:function(evt){
            evt._target = this;
            this._dispatcher.dispatchEvent(evt);
        }
    };
    module.exports = EventDispatcher;
    
}());


/** WEBPACK FOOTER **
 ** ./holiday-map/util/eventdispatcher.js
 **/